import { Box, BoxProps, Button, Stack, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export default function BtnExportar({
    boxProps
}: BtnExportarProps) {
    return (
        <Box {...boxProps}>
            <Typography component="div" variant="subtitle2" color="gray">Com selecionados:</Typography>

            <Stack direction="row" spacing={2}>
                <Button variant="outlined" disabled size="small" startIcon={<FileDownloadOutlinedIcon />}>
                    Exportar
                </Button>
            </Stack>
        </Box>
    )
}

interface BtnExportarProps {
    boxProps: BoxProps
}